import { render } from "./buy-canceled.vue?vue&type=template&id=29aff8dc&scoped=true"
import script from "./buy-canceled.vue?vue&type=script&lang=ts"
export * from "./buy-canceled.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-29aff8dc"

export default script